<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/13z5g8O/images/cover.jpg?1711065641291" alt="This image is the cover for the book Joyful Stitching"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Joyful Stitching
      </h1>
      <p class="bookDescription body article font2">
        <p>Stitch playful projects  Dive into Laura’s delightful world of embroidery and learn how to create small, free-form embroidery pieces that are alive with color and texture. With instructions for 21 basic embroidery stitches and 6 projects, all in Laura’s signature colorful, whimsical style, you’ll transform a flat, plain surface into a joyful, design-packed art piece. Stitch on wool, felt, or silk, and enjoy the simple pleasure of slow stitching. Includes a gallery of display ideas, as well as additional ideas for using free-form stitching.  • Begin with simple shapes and fill them with improvisational stitchery • Change up the provided designs, swapping out colors and trying new stitch combinations, to create your own unique work • From popular, best-selling author and teacher Laura Wasilowski</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Laura Wasilowski
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      C&T Publishing, Inc
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8fac3b8e